import { getInstanceFromElement } from "./getInstanceFromElement.js";
import { getAncestorWhere } from "../utils/index.js";
function getClosestParent(childInstance, ParentConstructor) {
  const parentEl = getAncestorWhere(
    childInstance.$el,
    (element) => element && getInstanceFromElement(element, ParentConstructor) !== null
  );
  return parentEl ? getInstanceFromElement(parentEl, ParentConstructor) : null;
}
export {
  getClosestParent
};
//# sourceMappingURL=getClosestParent.js.map
